<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import { mapMutations } from "vuex";
import { ssoLogin } from "@/api/back.js";
import { clearStorage, getStorage } from "@/utils";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
window.APP_CONFIG = window.APP_CONFIG || {};
export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
    };
  },
  async created() {
    let { code } = this.$route.query;
    code = code || window.location.search.split("=")[1];
    console.log("code", typeof code);
    if (code) {
      this.getSSOLogin(code); //华师登录回调
    } else {
      //if(!getStorage('token', 0)) {
      //this.firstLogin(); //首次登录
      //}
    }
  },
  methods: {
    ...mapMutations({
      SET_ROLE: "user/SET_ROLE",
      SET_TOKEN: "user/SET_TOKEN",
      UPDATE_USER_NAME: "user/UPDATE_USER_NAME",
      SET_HUA_SHI: "user/SET_HUA_SHI",
      SET_NICKNAME: "user/SET_NICKNAME",
    }),
    async getSSOLogin(code) {
      const res = await ssoLogin({ code });
      if (res.code === 200) {
        clearStorage();
        const { token, role, userName, nickName } = res;
        this.SET_ROLE(role);
        this.SET_TOKEN(token);
        this.UPDATE_USER_NAME(userName);
        this.SET_NICKNAME(nickName);
        this.SET_HUA_SHI("1");
        window.location.href = "/" + window.location.hash;
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    async firstLogin() {
      let token = getStorage("token", 0);
      if (!token || token === "") {
        let form = {
          username: "visitor@qq.com",
          password: "123456",
        };
        await this.$store.dispatch("user/LoginForm", form);
      }
    },
  },
};
</script>
